import { useState, useEffect } from "react";
import { Input } from "antd";
import { ChantButton } from "../../../CommonComponents";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../store/adminData/adminData";
import { db } from "../../../services/firebaseService/connection";
import { fbGetPartners } from "../../../services/firebaseService/endPoints/admin/partners";
import { doc, setDoc } from "firebase/firestore";
import { getWebsiteConfig } from "../../../services/firebaseService/endPoints/admin/website";
import { postUpdateCDNUtil } from "../../../helperFunctions/util";
import AdminContainer from "../admin-container/AdminContainer";

const CommunityPartners = () => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];

  const [overview, setOverview] = useState("");
  const [partners, setPartners] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const fetchData = () => {
    getWebsiteConfig(currentGroup).then((data) => {
      setOverview((data.communityPartners || {}).overview || "");
    });
    fbGetPartners(currentGroup).then((data) => {
      const filtered = data.filter(
        (partner) =>
          (!partner.status || partner.status === "Active") &&
          partner.displayOn.includes("Website: Partners")
      );
      setPartners(filtered);
    });
  };

  useEffect(() => {
    fetchData();
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveToFirebase = async () => {
    setIsSaving(true);
    const communityPartners = { overview };
    const gd = adminData.data;
    const identityFields = {
      groupName: gd.groupName || "",
      clubName: gd.clubName || "",
      leagueName: gd.leagueName || "",
      country: gd.country || "",
      ...(gd.clubId ? { clubId: gd.clubId } : {}),
      ...(gd.leagueId ? { leagueId: gd.leagueId } : {}),
    };
    const docRef = doc(db, "website", gd.id);
    await setDoc(docRef, { communityPartners, ...identityFields }, { merge: true });
    fetchData();
    postUpdateCDNUtil(currentGroup);
    setIsSaving(false);
  };

  let primaryColor = "";
  if (adminData?.data?.configuration?.primaryColor) {
    const { r, g, b } = adminData.data.configuration.primaryColor;
    primaryColor = `rgb(${r}, ${g}, ${b})`;
  }

  return (
    <AdminContainer>
      <p style={{ fontSize: "20", fontWeight: "bold", marginBottom: -20 }}>
        Community Partners <span style={{ fontSize: 14 }}>(optional)</span>
      </p>
      <div className="chant-form-body" style={{ padding: "0px 1rem" }}>
        <div style={{ marginBottom: "16px" }}>
          <label>Overview</label>
          <Input.TextArea
            value={overview}
            maxLength={1000}
            name="overview"
            placeholder="(optional) brief description (max 250 chars)"
            tabIndex="2"
            onChange={(e) => setOverview(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-center">
          <div className="p-2">
            <ChantButton
              style={{
                backgroundColor: primaryColor,
                borderColor: primaryColor,
              }}
              loading={isSaving}
              onClick={saveToFirebase}
            >
              Save
            </ChantButton>
          </div>
        </div>
      </div>
      <div className="row" style={{ padding: "0px 1rem" }}>
        <div className="col-12">
          <div className="row">
            <div className="col">
              <p>
                The partners listed below will appear in the Partners section
                of your website. Set via the Partners section of the admin
                dashboard.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <ul style={{ listStyleType: "none" }}>
                {partners.map((partner) => (
                  <li key={partner.id}>{partner.name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </AdminContainer>
  );
};

export default CommunityPartners;
